import m from "../../geodata/es2015/australiaHigh";
window.am4geodata_australiaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/australiaHigh.js
// module id = null
// module chunks = 